module.exports = __webpack_public_path__ + "img/icon-checkmark-outline.1d83c6d8.svg";